import { render, staticRenderFns } from "./CorporationDoc.vue?vue&type=template&id=09d76d36&scoped=true&"
import script from "./CorporationDoc.vue?vue&type=script&lang=js&"
export * from "./CorporationDoc.vue?vue&type=script&lang=js&"
import style0 from "./CorporationDoc.vue?vue&type=style&index=0&id=09d76d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d76d36",
  null
  
)

export default component.exports